import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule),
    //canActivate: [AuthGuardService]
  },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'games/:id',
    loadChildren: () => import('./games/games.module').then( m => m.GamesPageModule)
  },
  {
    path: 'edit-game',
    loadChildren: () => import('./edit-game/edit-game.module').then( m => m.EditGamePageModule)
  },
  {
    path: 'game-attendance/:id',
    loadChildren: () => import('./game-attendance/game-attendance.module').then( m => m.GameAttendancePageModule)
  },
  {
    path: 'attend-action',
    loadChildren: () => import('./attend-action/attend-action.module').then( m => m.AttendActionPageModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then( m => m.RegistrationPageModule)
  },
  {
    path: 'verify-email',
    loadChildren: () => import('./verify-email/verify-email.module').then( m => m.VerifyEmailPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'edit-team',
    loadChildren: () => import('./edit-team/edit-team.module').then( m => m.EditTeamPageModule)
  },
  {
    path: 'invite-player',
    loadChildren: () => import('./invite-player/invite-player.module').then( m => m.InvitePlayerPageModule)
  },
  {
    path: 'stats',
    loadChildren: () => import('./stats/stats.module').then( m => m.StatsPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then( m => m.AboutPageModule)
  },  {
    path: 'edit-venue',
    loadChildren: () => import('./edit-venue/edit-venue.module').then( m => m.EditVenuePageModule)
  },
  {
    path: 'venues',
    loadChildren: () => import('./venues/venues.module').then( m => m.VenuesPageModule)
  },
  {
    path: 'select-avatar',
    loadChildren: () => import('./select-avatar/select-avatar.module').then( m => m.SelectAvatarPageModule)
  },
  {
    path: 'join-team',
    loadChildren: () => import('./join-team/join-team.module').then( m => m.JoinTeamPageModule)
  }


];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
